<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-07-27 09:24:27
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2025-01-08 15:31:29
 * @FilePath: /wemeet-admin-new/src/views/brand/brandList.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <div>
    <vab-query-form>
      <vab-query-form-left-panel :span="12">
        <el-button :icon="Plus" type="primary" @click="addEnter()">添加机构列表</el-button>
      </vab-query-form-left-panel>
      <vab-query-form-right-panel :span="12">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item>
            <el-input v-model.trim="queryForm.name" clearable placeholder="请输入机构列表名称" />
          </el-form-item>
          <el-form-item>
            <el-button :icon="Search" type="primary" @click="queryData">查询</el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" border :data="list" @selection-change="handleSelectionChange">
      <el-table-column label="序号" type="index" width="80" />
      <el-table-column label="机构列表名称" prop="name" show-overflow-tooltip />
      <el-table-column label="备注" prop="remark" show-overflow-tooltip />
      <el-table-column label="机构数量总计" prop="enterpriseNum" show-overflow-tooltip />
      <el-table-column label="上线机构数量" prop="showEnterpriseNum" show-overflow-tooltip />
      <el-table-column label="创建时间" prop="createTime" show-overflow-tooltip />
      <el-table-column label="操作" show-overflow-tooltip width="520">
        <template #default="{ row }">
          <el-button plain type="info" @click="handleCopy(row)">复制</el-button>
          <el-button plain type="info" @click="addEnter(row)">编辑</el-button>
          <el-button plain type="info" @click="handleManage(row)">管理</el-button>
          <el-button plain type="danger" @click="handleDelete(row)">删除</el-button>
        </template>
      </el-table-column>
      <template #empty>
        <!-- <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        /> -->
        <el-empty class="vab-data-empty" description="暂无数据" />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.pageNum"
      :layout="layout"
      :page-size="queryForm.pageSize"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />

    <edit ref="editRef" :meeting-code="queryForm.meetingCode" @fetch-data="fetchData" />
  </div>
</template>

<script>
  import {
    defineComponent,
    defineAsyncComponent,
    getCurrentInstance,
    onMounted,
    reactive,
    toRefs,
    onActivated,
  } from 'vue'

  import { Delete, Plus, Search } from '@element-plus/icons'
  import { enterpriseGroupQueryList, groupCopy, delEnterpriseGroup } from '@/api/enterPriseApi'
  import { useRoute } from 'vue-router'
  import { ElMessageBox } from 'element-plus'
  export default defineComponent({
    name: 'Brand',
    components: {
      Edit: defineAsyncComponent(() => import('./components/enterpriseEdit.vue')),
    },
    setup() {
      const { proxy } = getCurrentInstance()
      const route = useRoute()
      const state = reactive({
        queryForm: {
          name: '',
          pageNum: 1,
          pageSize: 10,
          meetingCode: route.query.meetingCode,
        },
        activeName: 'first',
        exportPosterRef: null,
        total: 0,
        listLoading: false,
        list: [],
        layout: 'total, sizes, prev, pager, next, jumper',
        editRef: null,
        previewDialog: null,
        previewQrcode: '',
        previewWebSite: '',
        upLoadRef: null,
        resultRef: null,
        productUploadRef: null,
        chooseVal: [],
        fullscreenLoading: false,
        dialogVisible: false,
        posterUrl: '',
        checkRow: {},
      })

      /**
       * @description: 编辑展商
       * @param {*} row
       * @return {*}
       */
      const handleEdit = (row) => {
        proxy.$router.push({
          path: '/exhibitionManage/brandEdit',
          query: {
            meetingCode: state.queryForm.meetingCode,
            id: row.exhibitorCode,
            industryType: row.industryType,
            meetingType: state.queryForm.meetingType,
          },
        })
      }

      const handleConfig = (row) => {
        proxy.$router.replace(`/page/pageConfigModule/${row.id}`)
      }

      const handleDelete = (row) => {
        if (row.id) {
          proxy.$baseConfirm('你确定要删除当前项吗', null, async () => {
            const { msg } = await delEnterpriseGroup(row.id)
            proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
            await fetchData()
          })
        }
      }

      const queryData = () => {
        fetchData()
      }

      const fetchData = async () => {
        state.listLoading = true
        state.queryForm.meetingCode = route.query.meetingCode
        const { data } = await enterpriseGroupQueryList(state.queryForm)
        state.list = data.list
        state.total = data.total
        state.listLoading = false
      }

      const handleSizeChange = (val) => {
        state.queryForm.pageSize = val
        fetchData()
      }
      const handleCurrentChange = (val) => {
        state.queryForm.pageNum = val
        fetchData()
      }

      const shopStatusChange = async (row) => {
        try {
          let obj = {
            status: row.status,
            exhibitorCode: row.exhibitorCode,
          }
          await editBrandStatus(obj)
          proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
        } catch (e) {
          proxy.$baseMessage(`操作失败`, 'error', 'vab-hey-message-error')
          console.log(e)
        }

        fetchData()
      }

      onMounted(() => {
        fetchData()
      })

      const addEnter = (row) => {
        state.editRef.handleOpen(row)
      }

      const handleCopy = (row) => {
        ElMessageBox.prompt('请确认要复制并生成一个新的机构列表', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^\S.*$/,
          inputErrorMessage: '机构列表名称不能为空',
        })
          .then(async ({ value }) => {
            console.log(value)
            await groupCopy({
              name: value,
              id: row.id,
            })
            proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
            fetchData()
          })
          .catch(() => {
            // proxy.$baseMessage(`操作失败`, 'info', 'vab-hey-message-info')
          })

        // proxy.$baseConfirm(
        //   '请确认要复制并生成一个新的机构列表',
        //   null,
        //   async () => {
        //     proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
        //   }
        // )
      }

      const handleManage = (row) => {
        proxy.$router.push({
          path: '/exhibitionManage/enterpriseCategory',
          query: {
            meetingCode: state.queryForm.meetingCode,
            groupId: row.id,
          },
        })
      }
      return {
        ...toRefs(state),
        handleEdit,
        queryData,
        fetchData,
        handleSizeChange,
        handleCurrentChange,
        handleDelete,
        shopStatusChange,
        handleConfig,
        Delete,
        Search,
        Plus,
        addEnter,
        handleCopy,
        handleManage,
      }
    },
  })
</script>
<style lang="scss" scoped></style>
